/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getList = (buildingId, payload, callback) =>
  req.list(
    c.GET_LIST,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_additional_items?isPaginate=1`,
    payload,
    callback
  );

export const showData = (buildingId, id, payload, callback) =>
  req.item(
    c.SHOW_DATA,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_additional_items/${id}`,
    payload,
    callback
  );

export const createData = (buildingId, payload, callback) =>
  req.create(
    c.CREATE_DATA,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_additional_items`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateData = (buildingId, id, payload, callback) =>
  req.update(
    c.UPDATE_DATA,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_additional_items/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeData = (buildingId, id, payload, callback) =>
  req.remove(
    c.REMOVE_DATA,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_additional_items/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

  export const getAdditionalCostList = (payload, callback) =>
  req.list(
    c.GET_ADDITIONAL_COST_LIST,
    'api/v1/rpt/administrator/buildings/settings/building_additional_costs?isPaginate=1',
    payload,
    callback
  );